import type { EndUserDashboardState } from 'services/api/endUserDashboardApi.data';
import { applyEndUserProfileToStore } from 'services/endUser/hydrateEndUserProfile';
import { loadEndUserDashboardState } from 'services/endUser/loadEndUserDashboardState';

import type { AppDispatch } from 'store/store';

/** Forces GET /eu/{euId}/state and applies the latest profile fields to Redux. */
export const refreshEndUserDashboardState = async (
  euId: string,
  idToken: string,
  dispatch: AppDispatch
): Promise<EndUserDashboardState | null> => {
  try {
    const dashboard = await loadEndUserDashboardState(euId, idToken, { force: true });
    applyEndUserProfileToStore(dashboard, dispatch);
    return dashboard;
  } catch {
    return null;
  }
};
